module.exports = __webpack_public_path__ + "static/media/logo_1_meireles.12d7ed30.svg";